import React from 'react';
import Nav from "./nav/Nav";
import NavItem, {NavItemLink, NavTitle1, NavTitle2} from "./nav/NavItem";

export default function GsdeNav(){
    return(
        <Nav>
            <NavItem to="/" activeOnlyWhenExact={true}>
                <NavTitle1>首页</NavTitle1>
                <NavTitle2>HOME</NavTitle2>
            </NavItem>
            <NavItem to="/company">
                <NavTitle1>公司简介</NavTitle1>
                <NavTitle2>COMPANY</NavTitle2>
            </NavItem>
            <NavItemLink to="http://www.gsde.shop:5534">
                <NavTitle1>云平台</NavTitle1>
                <NavTitle2>CLOUD</NavTitle2>
            </NavItemLink>
            <NavItem to="/products" >
                <NavTitle1>产品介绍</NavTitle1>
                <NavTitle2>PRODUCTS</NavTitle2>
            </NavItem>
            <NavItem to="/classic">
                <NavTitle1>经典案例</NavTitle1>
                <NavTitle2>CLASSIC&nbsp;CASE</NavTitle2>
            </NavItem>
            <NavItem to="/contact">
                <NavTitle1>联系我们</NavTitle1>
                <NavTitle2>CONTACT&nbsp;US</NavTitle2>
            </NavItem>
            <NavItem to="/download">
                <NavTitle1>文件下载</NavTitle1>
                <NavTitle2>DOWNLOAD</NavTitle2>
            </NavItem>
        </Nav>
    )
}